<template>
  <div
    class="primary-container with-new-navbar"
  >
    <GoogleOneTap v-if="displayOneTap" />

    <div
      v-if="previewCampaign"
      :style="campaignStyle"
    >
      Previewing {{ $store.state.session.session.preview_campaign.description }}
      <a
        href="?preview_campaign=reset"
        title="Exit campaign preview"
        style="margin-left: 10px;
        color: #2980b9;"
      >&#x2716;</a>
    </div>

    <div
      v-if="showOverlay"
      id="sumo-main-overlay"
      class="active"
    />

    <!-- Navbar -->
    <NavBarHeader
      :group="browse.group"
    />

    <main :class="{ 'mt-0': !allowStickyHeader }">
      <div>
        <form
          v-if="isHijackedUser"
          :action="getReleaseUserUrl()"
          method="POST"
        >
          <p class="float-left ml-5 mr-1">
            You are currently working on behalf of {{ getCurrentUser.username }}
          </p>
          <input
            type="hidden"
            name="csrfmiddlewaretoken"
            :value="csrf"
          >
          <button>Release user</button>
        </form>
      </div>
      <nuxt />
    </main>

    <!-- ******* FOOTER ******* -->
    <Footer />

    <ScrollToTop />
  </div>
</template>

<script>
import BasePageMixin from '~/mixins/base-page-mixin';
import ScrollToTop from '../components/common/ScrollToTop.vue';
import Footer from '../components/common/Footer.vue';
import NavBarHeader from '../components/common/NavBarHeader.vue';
import GoogleOneTap from '../components/common/GoogleOneTap.vue';

// only load ui goodies in the browser
if (process.browser) {
  window.dataLayer = window.dataLayer || [];
  window.bannersJs = window.bannersJs || [];
}

export default {
  components: {
    ScrollToTop,
    Footer,
    NavBarHeader,
    GoogleOneTap,
  },
  mixins: [BasePageMixin],
};
</script>

<style lang="scss">
@import '~/../static/css/mdb.css';
@import '~/../static/css/flickity.min.css';
@import '~/../static/css/sumo.css';
@import '~/../static/css/project.css';
@import '~/../static/css/sumo-navbar.css';
@import '~/../static/css/sumo-new-navbar.css';
@import '~/../static/css/banner.css';
@import '~/../static/css/sumo-new-global.css';
@import '~/../static/css/vue-sumo-browse.css';
@import '~/../static/css/sumo-taco.css';
@import '~/../static/css/sumo-product.css';
@import '~/styles/global';

.primary-container {
  font-size: 14px;
}

.carousel-cell-image {
  object-fit: cover;
}
</style>
